var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRavenLogo = function SvgRavenLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.298 86.626"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ravenLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h254.298v86.626H0z",
    "data-name": "Rectangle 2254"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ravenLogo_svg__a)",
    "data-name": "Group 3790"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.725 35.692s-18.121 9.661-30.2 16.706c-9.244 5.394-24.321 15.2-24.321 15.2s-7.54 4.066-17.4-1.74-14.493-12.177-16.241-13.336a9.5 9.5 0 0 0-5.335-1.213.6.6 0 0 0-.217-.067c-.465-.03-.928-.035-1.393-.046h-.015c-.424 0-.842-.018-1.264-.046-.209-.012-.424-.03-.638-.03a1 1 0 0 1 .046-.1c.046-.069.092-.145.14-.214a14.1 14.1 0 0 1 2.883-3.182c1.862-1.513 4.006-4.066 6.364-4.268 4.243-.354 8.116 4.117 11.537 6.211 3.143 1.92 5.657 3.856 9.6 3.856a26.9 26.9 0 0 0 11.074-2.014c1.257-.628 4.786-2.385 6.041-3.02 9.8-4.961 9.181-4.879 12.08-6.041a38 38 0 0 1 4.027-2.014l33.128-4.671a.3.3 0 0 1 .092.046",
    "data-name": "Path 13072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.503 51.203a10.2 10.2 0 0 1 2.2-.279c.078-.423.143-.845.219-1.269a10 10 0 0 0-.062-.373 6 6 0 0 0-.269-1.065 1.14 1.14 0 0 0-.472-.546 2 2 0 0 0-.219-.11c-.4.127-.8.265-1.2.4a.5.5 0 0 0-.023.115.27.27 0 0 1-.161.256c-.048.023-.088.058-.134.083-.207.11-.414.212-.621.32a4 4 0 0 0-.415.237c-.3.205-.582.44-.873.658a1 1 0 0 0-.06.05c-.219.193-.444.38-.656.578a6 6 0 0 0-.58.6.45.45 0 0 0-.134.338.3.3 0 0 1-.046.121.1.1 0 0 0 0 .076.07.07 0 0 0 .088.023 1 1 0 0 0 .117-.074.65.65 0 0 1 .295-.105 3 3 0 0 1 .4-.02 3 3 0 0 0 .375-.011c.106 0 .212-.012.318-.011s.251 0 .377 0h.53a1 1 0 0 0 .157 0 1 1 0 0 1 .316 0 1.7 1.7 0 0 0 .338 0 1.4 1.4 0 0 1 .177 0",
    "data-name": "Path 13073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    d: "m58.398 17.247.06 22.837-10.499 5.731V17.247Z",
    "data-name": "Path 13074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    d: "m75.571 36.065-10.066 1.006L65.358 0h10.441Z",
    "data-name": "Path 13075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    d: "m30.558 30.206 10.446-.757.354 19.7s-3.02 2.014-10.066 1.006Z",
    "data-name": "Path 13076"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.619 48.12v9.449h-2.873v-22.82h6.113a26 26 0 0 1 2.632.11 13 13 0 0 1 1.982.354 7.07 7.07 0 0 1 3.766 2.21 5.87 5.87 0 0 1 1.3 3.889 6.3 6.3 0 0 1-.46 2.475 5.6 5.6 0 0 1-1.287 1.893 6.8 6.8 0 0 1-1.982 1.314 10.7 10.7 0 0 1-2.565.75v.069l6.981 9.757h-2.869l-7.264-9.448Zm0-10.865v8.357h2.837q1.324 0 2.258-.085a8.5 8.5 0 0 0 1.676-.308 4.6 4.6 0 0 0 2.309-1.414 3.83 3.83 0 0 0 .813-2.542 3.6 3.6 0 0 0-.778-2.362 4.2 4.2 0 0 0-2.1-1.289 8.3 8.3 0 0 0-1.515-.272q-.884-.085-2.24-.085Z",
    "data-name": "Path 13077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.751 57.569 9.608-22.821h2.487l9.608 22.821h-3.12l-2.82-6.873h-9.86l-2.818 6.873Zm10.826-19.27q-1.579 4.261-3.014 7.743l-.884 2.15h7.819l-.9-2.144q-1.446-3.559-2.954-7.752Z",
    "data-name": "Path 13078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.101 54.028q1.278-3.736 2.754-7.538l4.528-11.735h2.873l-8.944 22.816h-2.51l-8.944-22.821h2.873l4.528 11.735q1.49 3.8 2.772 7.538Z",
    "data-name": "Path 13079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.956 55.063h12.1v2.507h-14.968V34.75h14.32v2.507h-11.452v7.371h10.172v2.5h-10.172Z",
    "data-name": "Path 13080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.119 47.473q2.169 3.018 4.284 6.207h.106q-.23-3.327-.23-6.787V34.748h2.89v22.823H237.3l-9.259-12.728q-2.4-3.327-4.284-6.207h-.106q.23 3.12.23 7.282v11.65H221V34.75h2.857Z",
    "data-name": "Path 13081"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    d: "M63.848 60.523c7.248-4.43 19.155-11.691 22.436-13.678L65.695 61.221Z",
    "data-name": "Path 13082"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1ad0f",
    d: "m72.776 55.663-7.151 4.994-.636-.24 7.787-4.752m16.333-10.784a8.1 8.1 0 0 0-2.213 1c-.456.248-24.188 14.737-24.188 14.737l3.058 1.158 21.636-15.102s2.273-1.791 1.708-1.791",
    "data-name": "Path 13083"
  }))));
};
export default SvgRavenLogo;